export default {"src":"/_next/static/media/icone-profile.df8ca0fe.svg","height":34,"width":28,"blurWidth":0,"blurHeight":0};